(function() {
    'use strict';
    
a3_cabin_reports.controller('FaqsCtrl', FaqsCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FaqsCtrl
    * @description 
    *   Shows Faqs
    * @ngInject
    */
function FaqsCtrl($scope, FaqFactory, $uibModal, $route) {

		var FAQs = FaqFactory.getFAQsFromStorage();

		$scope.state = 'faqs';
		$scope.newFAQCount=0;
		$scope.updatedFAQCount=0;
		$scope.openAnswer = openAnswer;
		$scope.FAQItems = FAQs;
		$scope.updateFAQs = updateFAQs;
		$scope.searchText = '';
		$scope.btnFilter='';

		for (var i = 0; i < FAQs.length; i++) {
			if (FAQs[i].newItems){
				$scope.newFAQCount += FAQs[i].newItems;
			}
		if (FAQs[i].updatedItems){
				$scope.updatedFAQCount += FAQs[i].updatedItems;
			}
		}

         /**
         * Open selected FAQ
         * @memberof FaqsCtrl 
         * @param {object} pair The FAQ
         */
		function openAnswer(pair) {
			var modalInstance = $uibModal.open({
				templateUrl: './views/Dialogs/dlgOpenAnswer.html',
				controller: 'FaqsModalCtrl',
				size: 'lg',
				resolve: {
					pair: function() {return pair;}
				}
			}); 

			modalInstance.result.then(function() {
			 //FAQ is no longer New or Updated
			 if (pair.IsNew || pair.WasUpdated){
				 for(var i=0;i<FAQs.length;i++){
					for(var j=0;j<FAQs[i].Subcategories.length;j++){
						for(var k=0;k<FAQs[i].Subcategories[j].Pairs.length;k++){
							if (FAQs[i].Subcategories[j].Pairs[k].Id == pair.Id){
								if(FAQs[i].Subcategories[j].Pairs[k].IsNew){
									FAQs[i].Subcategories[j].Pairs[k].IsNew = false;
									FAQs[i].newItems--;
								}
								if(FAQs[i].Subcategories[j].Pairs[k].WasUpdated){
									FAQs[i].Subcategories[j].Pairs[k].WasUpdated = false;
									FAQs[i].updatedItems--;
								}
							}
						}
					}
				 }
				 FaqFactory.setFAQsToStorage(FAQs);
				 $route.reload();
				}
			}, function() {})
		}

        /**
         * Filter FAQs
         * @memberof FaqsCtrl 
         * @param {string} searchText The search text
         * @param {string} btnFilter  New, updated or all
         */
		function updateFAQs(searchText, btnFilter) {
			var oldFAQs = FAQs;
			var FAQ = [];
			searchText = searchText.toLowerCase();
			for(var i=0; i<oldFAQs.length; i++) {

				var Category = {};
				Category.Subcategories = [];
				var showCategory = false;

				for(var j=0; j<oldFAQs[i].Subcategories.length; j++) {
					var Subcategory={};
					Subcategory.Pairs = [];
					var showSubCategory = false;
					for(var k=0; k<oldFAQs[i].Subcategories[j].Pairs.length; k++) {
						var question = oldFAQs[i].Subcategories[j].Pairs[k].Question.toLowerCase();
						var answer = oldFAQs[i].Subcategories[j].Pairs[k].Answer.toLowerCase();
						
						if (((question.indexOf(searchText) > -1) || (answer.indexOf(searchText) > -1)) && 
									(!btnFilter || (btnFilter=='new' && oldFAQs[i].Subcategories[j].Pairs[k].IsNew) 
										|| (btnFilter=='updated' && oldFAQs[i].Subcategories[j].Pairs[k].WasUpdated)))
						 {
							showCategory = true;
							showSubCategory = true;
							Subcategory.Pairs.push(oldFAQs[i].Subcategories[j].Pairs[k]);
						}
					}
					if (showSubCategory) {
						Subcategory.SubcategoryDescription = oldFAQs[i].Subcategories[j].SubcategoryDescription;
						Category.Subcategories.push(Subcategory);
					}
				}
				if(showCategory){
					Category.CategoryDescription = oldFAQs[i].CategoryDescription;
					FAQ.push(Category);
				}
			}
			$scope.FAQItems = FAQ;
		}

	}

})();